<template>
  <div>
    <barra-navegacao :visiblebutton="true"/>
    <div class="dashboard container-fluid py-4" v-if="resumo">
      
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h3 class="font-weight-bold" style="color: #303f9f;">Visão Geral do Sistema</h3>
        <b-button variant="outline-primary" size="sm" @click="carregarDados">
          <b-icon icon="arrow-clockwise"></b-icon> Atualizar
        </b-button>
      </div>

      <!-- Cards de Resumo -->
      <b-row class="mb-4">
        <b-col cols="12" md="12" lg="4" class="mb-3">
          <b-card no-body class="shadow-sm border-0 h-100 summary-card cursor-pointer" @click="navegarPara('/ocorrencia/gerenciar')">
            <b-card-body class="d-flex flex-column align-items-center justify-content-center text-center">
              <div class="icon-circle bg-light-primary mb-3">
                <b-icon icon="clipboard-data" scale="1.5" variant="primary"></b-icon>
              </div>
              <h2 class="font-weight-bold text-primary mb-1">{{ resumo.chamadosAbertos + resumo.chamadosEmAtendimento + resumo.chamadosFinalizados }}</h2>
              <span class="text-muted font-weight-bold" style="font-size: 0.9rem;">Ocorrências Totais</span>
              <div class="d-flex w-100 justify-content-around mt-3">
                <div class="text-center" @click.stop="navegarPara('/ocorrencia/gerenciar')">
                  <span class="d-block text-danger font-weight-bold">{{ resumo.chamadosAbertos }}</span>
                  <small class="text-muted">Abertas</small>
                </div>
                <div class="text-center" @click.stop="navegarPara('/chamados-abertos')">
                  <span class="d-block text-warning font-weight-bold">{{ resumo.chamadosEmAtendimento }}</span>
                  <small class="text-muted">Em Atend.</small>
                </div>
                <div class="text-center">
                  <span class="d-block text-success font-weight-bold">{{ resumo.chamadosFinalizados }}</span>
                  <small class="text-muted">Finalizadas</small>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>

        <b-col cols="12" md="6" lg="4" class="mb-3">
          <b-card no-body class="shadow-sm border-0 h-100 summary-card cursor-pointer" @click="navegarPara('/checklist/lista')">
            <b-card-body class="d-flex flex-column align-items-center justify-content-center text-center">
              <div class="icon-circle bg-light-success mb-3">
                <b-icon icon="check2-square" scale="1.5" variant="success"></b-icon>
              </div>
              <h2 class="font-weight-bold text-success mb-1">{{ resumo.totalChecklists }}</h2>
              <span class="text-muted font-weight-bold" style="font-size: 0.9rem;">Total de Checklists</span>
              <b-progress class="w-100 mt-2 mb-2" height="6px" :value="calcularProgresso(resumo.checklistsConcluidos, resumo.totalChecklists)" variant="success"></b-progress>
              <div class="d-flex w-100 justify-content-around mt-2">
                <div class="text-center">
                  <span class="d-block text-warning font-weight-bold">{{ Math.max(0, resumo.totalChecklists - (resumo.checklistsConcluidos + (resumo.checklistsCancelados || 0) + (resumo.checklistsIniciados || 0))) }}</span>
                  <small class="text-muted">Pendentes</small>
                </div>
                <div class="text-center">
                  <span class="d-block text-primary font-weight-bold">{{ resumo.checklistsIniciados || 0 }}</span>
                  <small class="text-muted">Iniciados</small>
                </div>
                <div class="text-center">
                  <span class="d-block text-success font-weight-bold">{{ resumo.checklistsConcluidos }}</span>
                  <small class="text-muted">Concluídos</small>
                </div>
                <div class="text-center">
                  <span class="d-block text-danger font-weight-bold">{{ resumo.checklistsCancelados || 0 }}</span>
                  <small class="text-muted">Cancelados</small>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>

        <b-col cols="12" md="6" lg="4" class="mb-3">
          <b-card no-body class="shadow-sm border-0 h-100 summary-card cursor-pointer" @click="navegarPara('/inventario/lista')">
            <b-card-body class="d-flex flex-column align-items-center justify-content-center text-center">
              <div class="icon-circle bg-light-info mb-3">
                <b-icon icon="box-seam" scale="1.5" variant="info"></b-icon>
              </div>
              <h2 class="font-weight-bold text-info mb-1">{{ resumo.totalInventarios }}</h2>
              <span class="text-muted font-weight-bold" style="font-size: 0.9rem;">Total de Inventários</span>
              <b-progress class="w-100 mt-2 mb-2" height="6px" :value="calcularProgresso(resumo.inventariosConcluidos, resumo.totalInventarios)" variant="info"></b-progress>
              <div class="d-flex w-100 justify-content-around mt-2">
                <div class="text-center">
                  <span class="d-block text-warning font-weight-bold">{{ Math.max(0, resumo.totalInventarios - (resumo.inventariosConcluidos + (resumo.inventariosCancelados || 0) + (resumo.inventariosIniciados || 0))) }}</span>
                  <small class="text-muted">Pendentes</small>
                </div>
                <div class="text-center">
                  <span class="d-block text-primary font-weight-bold">{{ resumo.inventariosIniciados || 0 }}</span>
                  <small class="text-muted">Iniciados</small>
                </div>
                <div class="text-center">
                  <span class="d-block text-info font-weight-bold">{{ resumo.inventariosConcluidos }}</span>
                  <small class="text-muted">Concluídos</small>
                </div>
                <div class="text-center">
                  <span class="d-block text-danger font-weight-bold">{{ resumo.inventariosCancelados || 0 }}</span>
                  <small class="text-muted">Cancelados</small>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

    <!-- Gráficos Nativos via Vue/Bootstrap -->
    <b-row>
      <!-- Por Setor -->
      <b-col cols="12" lg="6" class="mb-4">
        <b-card header-bg-variant="transparent" header-border-variant="light" class="shadow-sm border-0 h-100">
          <template #header>
            <h5 class="mb-0 font-weight-bold text-secondary">Problemas por Setor</h5>
          </template>
          <div class="p-3" v-if="setores.length > 0">
            <div v-for="(item, index) in setores" :key="index" class="mb-4">
              <div class="d-flex justify-content-between mb-1">
                <span class="font-weight-bold text-dark">{{ item.setor }}</span>
                <span class="badge badge-primary badge-pill">{{ item.total }}</span>
              </div>
              <b-progress :value="item.total" :max="totalGeralSetores" :variant="getVariantePorIndice(index)" height="8px"></b-progress>
            </div>
          </div>
          <div v-else class="text-center text-muted p-4">
            Nenhum dado encontrado.
          </div>
        </b-card>
      </b-col>

      <!-- Locais Criticos -->
      <b-col cols="12" lg="6" class="mb-4">
        <b-card header-bg-variant="transparent" header-border-variant="light" class="shadow-sm border-0 h-100">
          <template #header>
            <h5 class="mb-0 font-weight-bold text-danger">Locais Mais Críticos (Top 5)</h5>
          </template>
          <div class="p-3" v-if="locais.length > 0">
            <div v-for="(item, index) in locais" :key="index" class="mb-4">
              <div class="d-flex justify-content-between mb-1">
                <span class="font-weight-bold text-dark text-truncate" style="max-width: 80%;">{{ item.local }}</span>
                <span class="badge badge-danger badge-pill">{{ item.total }}</span>
              </div>
              <b-progress :value="item.total" :max="maiorLocal" variant="danger" height="8px"></b-progress>
            </div>
          </div>
          <div v-else class="text-center text-muted p-4">
            Nenhum dado encontrado.
          </div>
        </b-card>
      </b-col>
    </b-row>

    </div>
  </div>
</template>

<script>
import BarraNavegacao from '../components/BarraNavegacao.vue';

export default {
  name: 'Dashboard',
  components: {
    BarraNavegacao
  },
  data() {
    return {
      resumo: null,
      setores: [],
      locais: []
    }
  },
  computed: {
    totalGeralSetores() {
      return this.setores.reduce((acc, curr) => acc + curr.total, 0);
    },
    maiorLocal() {
      if (this.locais.length === 0) return 0;
      return this.locais[0].total; // Já vem ordenado do backend
    }
  },
  mounted() {
    this.carregarDados();
  },
  methods: {
    carregarDados() {
      this.$loading(true);
      
      const p1 = this.$http.get('/dashboard/resumo');
      const p2 = this.$http.get('/dashboard/ocorrencias-por-setor');
      const p3 = this.$http.get('/dashboard/locais-criticos');

      Promise.all([p1, p2, p3])
        .then((responses) => {
          this.resumo = responses[0].data;
          this.setores = responses[1].data;
          this.locais = responses[2].data;
        })
        .catch(error => {
          console.error("Erro ao buscar dashboard", error);
          this.$alert("Erro ao buscar os dados do dashboard");
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    calcularProgresso(concluido, total) {
      if (!total || total === 0) return 0;
      return Math.round((concluido / total) * 100);
    },
    navegarPara(rota) {
      // Impede de adicionar na history caso ja esteja na mesma rota para evitar NavigationDuplicated error
      if(this.$route.path !== rota) {
        this.$router.push(rota);
      }
    },
    getVariantePorIndice(index) {
      const variants = ['primary', 'info', 'success', 'warning', 'dark'];
      return variants[index % variants.length];
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.summary-card {
  border-radius: 12px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.summary-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.1) !important;
}

.icon-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bg-light-primary { background-color: rgba(48, 63, 159, 0.1); }
.bg-light-warning { background-color: rgba(255, 193, 7, 0.15); }
.bg-light-success { background-color: rgba(40, 167, 69, 0.15); }
.bg-light-info { background-color: rgba(23, 162, 184, 0.15); }
</style>
